/**
 * Move the item at index `from` to index `to`, returning a new array.
 * Negative indexes count from the end. An index out of range returns the
 * list unchanged.
 *
 *      move(0, 2, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'a', 'd']
 *      move(-1, 0, ['a', 'b', 'c', 'd']); //=> ['d', 'a', 'b', 'c']
 */
export default function move<T>(from: number, to: number, list: T[]): T[] {
  const length = list.length;
  const positiveFrom = from < 0 ? length + from : from;
  const positiveTo = to < 0 ? length + to : to;

  if (positiveFrom < 0 || positiveFrom >= length || positiveTo < 0 || positiveTo >= length) {
    return list;
  }

  const result = list.slice();
  const [item] = result.splice(positiveFrom, 1);
  result.splice(positiveTo, 0, item);

  return result;
}
